import React, { FC, useRef, useCallback } from 'react';
import { Button } from 'common/button';
import clsx from 'classnames';
import { SelectInput } from 'common/form';
import { useAttachDocsContent } from 'pages/vehicle-documents/components/attach-docs-content/use-attach-docs-content';
import { LoadingSpinnerIcon } from 'common/icons';
import { AttachDocsContentProps } from './attach-docs-content.types';
import { AttachDocsContentPreset } from './attach-docs-content.preset';
import { DocumentItem } from './components';

import styles from './attach-docs-content.module.scss';

export const AttachDocsContent: FC<AttachDocsContentProps> = props => {
  const {
    closeFn,
    confirmFn,
    documentTypesAvailable,
    documents,
    errorMessage,
    isUploading,
    onAddAttach,
    onDeleteDocument,
  } = useAttachDocsContent(props);

  const inputRef = useRef<any>();
  const selectRef = useRef<any>();

  const onPickFile = useCallback(
    event => {
      const file = event.currentTarget.files[0] as File;
      onAddAttach(file, selectRef.current?.getValue().at(0));
      selectRef.current?.clearValue();
      inputRef.current.value = null;
    },
    [documents],
  );

  return (
    <div className={styles.container}>
      <input
        accept="application/pdf"
        className="hidden"
        ref={inputRef}
        role="button"
        type="file"
        onChange={onPickFile}
      />
      <div className="overflow-hidden flex flex-col gap-2 px-2">
        <SelectInput
          appendToBody
          error={errorMessage}
          innerRef={selectRef}
          isMulti={false}
          label="Tipo documental"
          options={documentTypesAvailable}
          required
          onSelect={option => {
            if (option?.value) {
              inputRef.current?.click();
            }
          }}
        />
        <div className={clsx('flex flex-col gap-2 overflow-auto scrollbar-hide my-2', styles.listContainer)}>
          {documents?.map(doc => (
            <DocumentItem doc={doc} key={doc.id} onDeleteDocument={onDeleteDocument} />
          ))}
        </div>
      </div>

      <div className="text-center pt-4 flex justify-center items-center gap-4">
        <Button disabled={isUploading} label="Cancelar" theme="outline" onClick={closeFn} />
        <Button disabled={isUploading} label={isUploading ? 'Cargando' : 'Aceptar'} onClick={confirmFn}>
          {isUploading && (
            <span className="ml-3">
              <LoadingSpinnerIcon className={styles.loading} />
            </span>
          )}
        </Button>
      </div>
    </div>
  );
};

AttachDocsContent.defaultProps = AttachDocsContentPreset;
